import React, { useState } from 'react';
import YouTube from 'react-youtube';
import { parseClasses } from '../../lib/ep';

const ResponsiveYouTube = (props) => {
	const [ is_playing, setIsPlaying ] = useState(false);

	const custom_opts = props?.opts ?? {};

	const is_portrait = props?.is_portrait ?? false;
	const video_proportion = props?.video_proportion ?? ((is_portrait) ? '324x575' : '16x9');

	const thumbnail = props?.thumbnail ?? false;
	
	const opts = {
		height:'100%',
		width:'100%',
		playerVars:Object.assign({}, {
			autoplay:0,
			controls:0,
			rel:0,
			showinfo:0,
			modestbranding:1,
			iv_load_policy:3,
		}, custom_opts),
	};

	const player_props = Object.assign({}, {...props});

	let classname = 'gui_pos_rel gui_responsive_youtube';
	classname = parseClasses(classname, props._class, 'youtube');

	if(thumbnail !== false) {
		const video_styles = {
			backgroundImage:`url(${thumbnail})`,
			backgroundPosition:'center',
			backgroundSize:'cover',
		};

		const playVideo = (e) => {
			e.stopPropagation();
			setIsPlaying(true);
		};

		return (
			<div class={classname} style={(!is_playing) ? video_styles : null}>
				<img src={`${window.cdn_url}img/blank_${video_proportion}.png`} width="100%" />

				{(is_playing) ? (
					<YouTube
						{...player_props}
						opts={{...opts, playerVars:{...opts.playerVars, autoplay:1 }}}
					/>
				) : (
					<a class='play_video_btn knk-play-round normal_button' onClick={(e) => playVideo(e)} />
				)}
			</div>
		)
	}

	return (
		<div class={classname}>
			<img src={`${window.cdn_url}img/blank_${video_proportion}.png`} width="100%" />

			<YouTube
				{...player_props}
				opts={opts}
			/>
		</div>
	)
}

export default ResponsiveYouTube;